"use strict";
/* eslint no-undef: 0 */

module.exports = FormData;